import { Member, MemberForAdmin, MemberEventsRaw, MemberSingle } from '@/types/Member.type'
import { Paginated } from '@/types/Paginated.type'
import { MemberSearchFilterListItem } from '@/types/MemberSearchFilterListItem.type'
import { State } from '@/store/member/state'
import { MyPendingSuggestionResponse } from '@/types/response/MyPendingSuggestionResponse.type'
import { MetaPager } from '@/types/API.type'
import { PendingRelationshipSuggestionForMemberResponse } from '@/types/response/PendingRelationshipSuggestionForMemberResponse.type'

export const SET_RELATIONSHIP_SUGGESTION_LIST = (
    state: State,
    payload: {
        pendingRelationshipSuggestionList: MyPendingSuggestionResponse
        pendingRelationshipSuggestionListPager: MetaPager
    }
) => {
    state.pendingRelationshipSuggestionList = payload.pendingRelationshipSuggestionList
    state.pendingRelationshipSuggestionListPager = payload.pendingRelationshipSuggestionListPager
}

export const SET_FAVORITE_MEMBER_LIST = (state: any, { favoriteMemberList }: any) => {
    state.favoriteMemberList = favoriteMemberList
}

export const SET_PENDING_RELATIONSHIP_SUGGESTION = (
    state: State,
    { pendingRelationshipSuggestion }: { pendingRelationshipSuggestion: PendingRelationshipSuggestionForMemberResponse }
) => {
    state.pendingRelationshipSuggestion = pendingRelationshipSuggestion
}


export const SET_CONTACT_MEMBER_LIST = (
    state: any,
    { contactMemberList }: { contactMemberList: Paginated<Member> }
) => {
    if (contactMemberList.currentPage === 1) {
        state.contactMemberList = contactMemberList
    } else {
        state.contactMemberList.currentPage = contactMemberList.currentPage
        state.contactMemberList.nbResults = contactMemberList.nbResults
        state.contactMemberList.results.push(...contactMemberList.results)
    }
}

export const SET_LOADING = (state: any, payload: any) => {
    Object.assign(state.loading, payload)
}

export const REMOVE_PENDING_SUGGESTION = (state: State, { suggestionId }: any) => {
    const suggestionIdIndex = state.pendingRelationshipSuggestionList.findIndex(
        suggestion => suggestion.id === suggestionId
    )

    state.pendingRelationshipSuggestionList = state.pendingRelationshipSuggestionList.filter(
        suggestion => suggestion.id !== suggestionId
    )

    if (suggestionIdIndex >= 0 && state.pendingRelationshipSuggestionListPager?.nbMaxResults) {
        state.pendingRelationshipSuggestionListPager.nbMaxResults--
    }
}

export const SET_SEARCHED_MEMBER_LIST = (
    state: any,
    { searchMemberResult }: { searchMemberResult: Paginated<Member> }
) => {
    if (searchMemberResult.currentPage === 1) {
        state.searchedMemberList = searchMemberResult
    } else {
        state.searchedMemberList.currentPage = searchMemberResult.currentPage
        state.searchedMemberList.nbResults = searchMemberResult.nbResults
        state.searchedMemberList.results.push(...searchMemberResult.results)
    }
}

export const SET_SEARCH_FILTERS = (
    state: any,
    { searchFilters }: { searchFilters: Array<MemberSearchFilterListItem> }
) => {
    state.searchFilters = searchFilters
}

export const SET_SELECTED_SEARCH_FILTERS = (state: any, { searchFiltersSelected }: any) => {
    Object.keys(searchFiltersSelected).forEach((key: string) => {
        searchFiltersSelected[key] = [...new Set(searchFiltersSelected[key])]
    })

    state.searchFiltersSelected = searchFiltersSelected
}

export const ADD_SEARCH_FILTER = (state: any, { category, value }: any) => {
    try {
        if (!state.searchFiltersSelected[category].includes(value)) {
            state.searchFiltersSelected[category].push(value)
        }
    } catch (e) {
        state.searchFiltersSelected[category] = [value]
    }

    state.searchFiltersSelected = { ...state.searchFiltersSelected }

    state.searchedMemberList.currentPage = 1 // Reinit page, because filters have changed
}

export const REMOVE_SEARCH_FILTER = (state: any, { category, value }: any) => {
    state.searchFiltersSelected[category] = state.searchFiltersSelected[category].filter(
        (selectedValue: any) => selectedValue !== value
    )

    if (state.searchFiltersSelected[category].length === 0) {
        delete state.searchFiltersSelected[category]
    }

    state.searchFiltersSelected = { ...state.searchFiltersSelected }
    state.searchedMemberList.currentPage = 1 // Reinit page, because filters have changed
}

export const SET_SAME_EVENTS_MEMBER_LIST = (state: any, { sameEventsMemberList }: any) => {
    state.sameEventsMemberList = sameEventsMemberList
}

export const SET_SORT_BY_MEMBER = (state: any, { sortBy }: any) => {
    state.sortMemberListBy = sortBy
}

export const CLEAR_SELECTED_FILTERS = (state: any) => {
    state.searchFiltersSelected = {}
}

export const SET_NATIONALITY_LIST = (state: any, { nationalityList }: any) => {
    state.nationalityList = nationalityList
}

export const SET_MEMBER_SINGLE = (state: State, { member }: { member: MemberSingle | null }) => {
    state.memberSingle.member = member
}

export const SET_MEMBER_FOR_ADMIN_SINGLE = (state: State, { member }: { member: MemberForAdmin | null }) => {
    state.memberSingle.memberForAdmin = member
}

export const SET_MEMBER_SINGLE_EVENTS = (state: State, { events }: { events: MemberEventsRaw | null }) => {
    state.memberSingle.memberEvents = events
}
